import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
import { defaultSmDate } from '../utils/formatter';

export interface ArtikelDetailKalkulation {
    artikelGruppeNr: number;
    artikelNr: string;
    lNr: number;
    lfnr: number;
    datum: string;
    ek1Eh: string;
    ek1: number;
    eh: string;
    ek2: number;
    vkProz: number;
    vk: number;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export const defaultArtikelDetailKalkulation: ArtikelDetailKalkulation = {
    artikelGruppeNr: 0,
    artikelNr: '',
    lNr: 0,
    lfnr: 0,
    datum: defaultSmDate,
    ek1Eh: '',
    ek1: 0,
    eh: '',
    ek2: 0,
    vkProz: 0,
    vk: 0,
};

export interface ArtikelDetailKalkulationFilter {
    artikelGruppeNr: number;
    artikelNr: string;
    lNr?: number;
    onlyHauptlieferant?: boolean;
    onlyLatest?: boolean;
}

export async function getArtikelDetailKalkulationen(
    filter: ArtikelDetailKalkulationFilter,
): Promise<ArtikelDetailKalkulation[]> {
    return callApi<ArtikelDetailKalkulation[]>(Controller.artikelDetailKalkulation + '/list', {
        filter,
    });
}

export function useArtikelDetailKalkulationList(
    filter: ArtikelDetailKalkulationFilter,
    apiOptions?: UseApiOptions<ArtikelDetailKalkulation[]>,
): QueryResult<ArtikelDetailKalkulation[]> {
    return useApi<ArtikelDetailKalkulation[]>(Controller.artikelDetailKalkulation + '/list', { filter }, apiOptions);
}

export async function addArtikelDetailKalkulation(artikelDetailKalkulation: ArtikelDetailKalkulation): Promise<void> {
    return callApi<void>(Controller.artikelDetailKalkulation + '/add', { artikelDetailKalkulation });
}
